module.exports = __webpack_public_path__ + "img/dynamic.deac08b7.png";